import i18next from 'i18next';
import { Heading } from 'yoso';
import { t } from '~/components/I18n';
import { useNoticeDetail } from '~/components/Support';
import { regularFormat } from '~/components/Util';
import './NoticeDetail.scss';

export type NoticeDetailProps = { id: string };
export const NoticeDetail = ({ id }: NoticeDetailProps) => {
  const { data } = useNoticeDetail({ id });
  const {
    title = '',
    body = '',
    registered,
    category = '',
    subCategory = '',
    originTitle = '',
  } = data || {};
  const prefixXltKey = `citizen_notice_prefix_${subCategory + category}`;
  const prefix = `[${t(prefixXltKey)}]`;
  return (
    <div className="notice-detail">
      <Heading level={4} className="notice-detail-header">
        {i18next.exists(prefixXltKey) ? prefix + title : originTitle}
        <small className="helvetica notice-detail-date">{regularFormat(registered, 'PP')}</small>
      </Heading>
      <div className="notice-detail-body" dangerouslySetInnerHTML={{ __html: body }} />
    </div>
  );
};
